var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      ref: "linkButtonModal",
      attrs: {
        title: _vm.isEdit ? "Edit Button" : "Add a Link Button",
        "class-name": "block-modal fade",
        "close-button": false,
        backdrop: false
      }
    },
    [
      _c("div", { staticClass: "d-flex-column justify-content-left" }, [
        _c(
          "div",
          { staticClass: "w-100 mb-3" },
          [
            _c("AppInput", {
              staticClass: "form-group",
              attrs: {
                icon: "/images/icons/ic-edit.svg",
                placeholder: "Button text",
                maxlength: "30"
              },
              model: {
                value: _vm.buttonTitle,
                callback: function($$v) {
                  _vm.buttonTitle = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "buttonTitle"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "w-100" },
          [
            _c("AppInput", {
              staticClass: "form-group",
              class: { "form-error": _vm.urlError },
              attrs: {
                icon: "/images/icons/ic-link.svg",
                placeholder: "https://..."
              },
              model: {
                value: _vm.buttonUrl,
                callback: function($$v) {
                  _vm.buttonUrl = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "buttonUrl"
              }
            }),
            _vm._v(" "),
            _vm.urlError
              ? _c("div", { staticClass: "text-sm stan-text-danger mt-1" }, [
                  _vm._v("\n\t\t\t\tPlease enter a valid link\n\t\t\t")
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      !_vm.isEdit
        ? _c("p", { staticClass: "text-light float-right mt-2 para-3" }, [
            _c("i", [_vm._v("Adding a link button disables plain text links")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "w-100 d-flex justify-content-end mt-4" }, [
        _c(
          "div",
          { staticClass: "button-group" },
          [
            _vm.isEdit
              ? _c(
                  "AppButton",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      name: "link-button-modal-remove-button",
                      outline: ""
                    },
                    on: { click: _vm.removeButton }
                  },
                  [_vm._v("\n\t\t\t\tRemove Button\n\t\t\t")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "AppButton",
              {
                attrs: {
                  name: "link-button-modal-save-button",
                  disabled: !_vm.isValid
                },
                on: { click: _vm.handleSave }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.isEdit ? "Save" : "Add") +
                    "\n\t\t\t"
                )
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }